module.exports = __webpack_public_path__ + "media/weployer/no-results-e6f27b47.svg";